.tenantPortal {
  font-family: var(--pm-font-family);

  h1 {
    font-size: 23px;
    font-weight: 600;
    margin: 0;
    word-break: break-all;
  }

  h2 {
    font-size: 18px !important;
    font-weight: 600 !important;
    font-family: var(--pm-font-family) !important;
    word-break: break-all;
  }
}

:global(body:has(.tenantPortal)) {
  font-family: var(--pm-font-family);
}

:global(.dark) .tenantPortal h1,
:global(.dark) .tenantPortal h2 {
  color: var(--pm-white);
}

:global(.theme-dark1) .tenantPortal h1,
:global(.theme-dark1) .tenantPortal h2 {
  color: var(--pm-text-primary);
}

.fs11 {
  font-size: 11px;
}

.fs12 {
  font-size: 12px;
}

.fs13 {
  font-size: 13px;
}

.fs14 {
  font-size: 14px;
}

.fs15 {
  font-size: 15px;
}

.fs16 {
  font-size: 16px;
}

.fs18 {
  font-size: 18px;
}

.fwSb {
  font-weight: 600;
}

.colorMain {
  color: var(--pm-black);
}

:global(.dark) .colorMain {
  color: var(--pm-white);
}

:global(.theme-dark1) .colorMain {
  color: var(--pm-text-primary);
}

.colorSecondary {
  color: var(--pm-grey5);
}

:global(.dark) .colorSecondary {
  color: var(--pm-grey7);
}

:global(.theme-dark1) .colorSecondary {
  color: var(--pm-text-tertiary);
}

.colorBlue {
  color: var(--pm-blue);
}

:global(.dark) .colorBlue,
:global(.theme-dark1) .colorBlue {
  color: var(--pm-blue-lighter);
}

.colorError {
  color: var(--pm-red);
}

.strikeThrough {
  text-decoration: line-through;
}
.MuiError {
  margin-top: 3px;
  margin-right: 14px;
  margin-bottom: 0;
  margin-left: 14px;
}
a {
  color: var(--pm-blue);
}
:global(.dark) a,
:global(.theme-dark1) a {
  color: var(--pm-blue-lighter);
}

.breakWord {
  word-break: break-word;
}

.capitalize {
  text-transform: capitalize !important;
}
